import React from 'react';

import * as Analytics from 'analytics/Analytics';
import {CICOItemIdsToAssignee} from 'constants/SampleStatusConstants';
import {ActionOrigin} from 'graphql-client/__generated/graphqlGlobalTypes';
import BaseCheckOutFromProcessTableModal, {
  BaseCheckoutFromProcessTableModalProps,
} from 'inventory/check-in-check-out/BaseCheckOutFromProcessTableModal';
import * as CICOActions from 'inventory/check-in-check-out/CICOActions';

export default function ReserveFromProcessTableModal(
  props: Omit<BaseCheckoutFromProcessTableModalProps, 'statusWarningTrackingParams' | 'onCheckOut'>
): JSX.Element {
  return (
    <BaseCheckOutFromProcessTableModal
      targetTaskIdsAndStorables={props.targetTaskIdsAndStorables}
      onCheckOut={(itemIdsToAssignee: CICOItemIdsToAssignee, comment?: string): void => {
        CICOActions.reserve(itemIdsToAssignee, {comment});
      }}
      onRequestClose={props.onRequestClose}
      shouldWarnIfReservedForCurrentUser={true}
      title="Reserve"
      actionVerb="reserved"
      statusWarningTrackingParams={{
        actionOrigin: props.analyticsMetadata?.actionOrigin ?? ActionOrigin.UI_UNDETERMINED,
        actionAttempted: 'reserve',
        eventGroupId: props.analyticsMetadata?.eventGroupId ?? Analytics.makeAnalyticsEventId(),
      }}
      analyticsMetadata={{...props.analyticsMetadata, modalType: 'reserve'}}
      shouldAlwaysShowSampleStatusTable={props.shouldAlwaysShowSampleStatusTable}
    />
  );
}
